import { AfterViewInit, Component, OnInit } from '@angular/core'
import { Platform } from '@ionic/angular/standalone'
import { VideoService } from '@service/video.service'
import { IonModule } from './shared/ion.module'

@Component({
    selector: 'app-video-root',
    styles: [
        `
      #video-loading {
        display: none;
      }
      #video-wrapper {
        z-index: 1000;
        position: absolute;
        top: 0;
        right: 2000px;
        bottom: 0;
        left: 0;
      }
      #dimm {
        background-color: black;
        opacity: 0.5;
        width: 100%;
        height: 100%;
        text-align: center;
      }
    `,
    ],
    template: `
    <!-- 비디오 -->
    <div class="middle-center" id="video-loading">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
    <div id="video-wrapper">
      <div id="dimm"></div>
    </div>
  `,
    imports: [IonModule]
})
/**
 * root video component
 */
export class VideoComponent implements OnInit, AfterViewInit {
  imgWidth: number
  halfWidth: number
  on = false

  constructor(private platform: Platform, private videoService: VideoService) {
    this.platform.ready().then(() => {
      this.imgWidth = this.platform.width()
      this.halfWidth = this.imgWidth / 2
    })
  }

  async ngOnInit() {}

  offVideo() {
    if (!this.on) return
    // const globalVideo = document.querySelector('video')
    const globalVideoWrapper = document.querySelector('#video-wrapper')
    globalVideoWrapper.setAttribute(
      'style',
      `position: absolute; top: 0; left: 0; right: 2000px; bottom: 0`,
    )
    const videoElement = document.querySelector('video')
    if (videoElement) videoElement.remove()
    // globalVideo.setAttribute('style', `width: 0`)
    // globalVideo.pause()

    const videoLoading = document.querySelector('#video-loading') as HTMLElement
    videoLoading.style.display = 'none'
  }

  ngAfterViewInit(): void {
    const videoLoading = document.querySelector('#video-loading') as HTMLElement

    document
      .querySelector('#dimm')
      .addEventListener('click', () => this.videoService.offVideo.next(new Date()))

    this.videoService.offVideo.subscribe(() => {
      this.offVideo()
    })

    this.videoService.video.subscribe(src => {
      this.on = false
      if (!src) return
      videoLoading.style.display = 'block'

      const globalVideoWrapper = document.querySelector('#video-wrapper')
      globalVideoWrapper.setAttribute(
        'style',
        `position: absolute; top: 0; left: 0; right: 0; bottom: 0;`,
      )

      setTimeout(() => {
        const videoElement: any = document.createElement('video')
        videoElement.setAttribute('playsinline', '')
        videoElement.setAttribute('autoplay', '')
        videoElement.setAttribute('loop', '')
        videoElement.setAttribute('controls', '')
        videoElement.setAttribute('controlsList', 'nodownload')
        videoElement.setAttribute('preload', 'auto')
        videoElement.setAttribute(
          'style',
          `position: absolute; width: ${this.imgWidth}px; height: ${this.imgWidth}px; top: 50%;\
transform: translateY(-${this.halfWidth}px);`,
        )
        const vSourceElement: any = document.createElement('source')
        vSourceElement.setAttribute('src', src)
        videoElement.appendChild(vSourceElement)
        globalVideoWrapper.appendChild(videoElement)

        // 동영상 off 조건 (ios, android)
        // if (this.platform.is('ios'))
        //   videoElement.addEventListener('webkitendfullscreen', e => {
        //     this.videoService.offVideo.next(new Date())
        //   })

        // const requestFull = () => {
        //   setTimeout(() => {
        //     try {
        //       if (videoElement.requestFullScreen) videoElement.requestFullScreen()
        //       else if (videoElement.mozRequestFullScreen) videoElement.mozRequestFullScreen()
        //       else if (videoElement.webkitRequestFullScreen) videoElement.webkitRequestFullScreen()
        //       else if (videoElement.webkitEnterFullScreen) videoElement.webkitEnterFullScreen()
        //     } catch (e) {
        //       requestFull()
        //     }
        //   }, 500)
        // }

        // if (this.platform.is('ios')) {
        //   requestFull()
        //   this.on = true
        //   return
        // }

        this.on = true
      }, 400)
    })
  }
}
